import React, {useEffect, useState} from 'react'
import {Col, Container, Row} from 'react-bootstrap'
import Accordion from 'react-bootstrap/Accordion'
import Swal from 'sweetalert2'
import {realiserAction, updateStatutAction} from '../../../../components/requests'
import moment from 'moment'
import ViewMessageAction from '../ViewMessageAction'
import {toast} from 'react-toastify'
import {KTSVG} from '../../../../_metronic/helpers'

const ViewActionForm = (props: any) => {
  const {dataActions, setDataActions, onSelectDemande, showModal} = props
  const [groupedByType, setGroupedByType] = useState<Record<string, any[]>>({})
  const [isOpen, setIsOpen] = useState<{[key: number]: boolean}>({})
  const statutColors: Record<string, string> = {
    NOUVELLE: 'badge-light-dark',
    ENCOURS: 'badge-light-info',
    TERMINEE: 'badge-light-primary',
    LU: 'badge-light-primary',
    NONLUE: 'badge-light-danger',
  }

  const handleRealiserActionSubmit = (action) => {
    const statutCode = action.statut ? action.statut.code : ''
    Swal.fire({
      title: 'Réaliser action',
      text: `Voulez-vous ${statutCode === 'NOUVELLE' ? 'démarrer' : 'terminer'} cette action ?`,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        const statutCodeModified = statutCode === 'NOUVELLE' ? 'ENCOURS' : 'TERMINEE'
        const response = await realiserAction(action.id, statutCodeModified)
        if (response?.status === 200 && response.data) {
          const updatedAction = response.data
          setDataActions((prev) => prev.map((a) => (a.id === updatedAction.id ? updatedAction : a)))
          return updatedAction
        } else {
          throw new Error('Échec de la réalisation de cette action.')
        }
      },
    })
      .then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Réaliser action',
            text: `Action ${statutCode === 'NOUVELLE' ? 'démarrée' : 'terminée'} avec succès`,
            icon: 'success',
            timer: 1500,
            showConfirmButton: false,
          })
        }
      })
      .catch((err) => {
        Swal.showValidationMessage(`Erreur : ${err.message}`)
      })
  }

  useEffect(() => {
    if (!dataActions || dataActions.length === 0) return

    const grouped = dataActions.reduce((acc: Record<string, any[]>, action: any) => {
      const typeLibelle = action.type?.libelle || ''
      if (!acc[typeLibelle]) {
        acc[typeLibelle] = []
      }
      acc[typeLibelle].push(action)
      return acc
    }, {})

    setGroupedByType(grouped)
  }, [dataActions])

  // mise à jour du statut message ( non lu ou lu )
  const changeStatusMessage = (statut, actionId) => {
    if (actionId) {
      const idToastRead = toast.loading('Changement de statut en cours...')
      updateStatutAction(actionId, statut)
        .then((actionRequest) => {
          if (actionRequest?.status === 200) {
            if (actionRequest?.data !== undefined) {
              const updatedAction = actionRequest.data
              setDataActions((prev) =>
                prev.map((a) => (a.id === updatedAction.id ? updatedAction : a))
              )
              toast.update(idToastRead, {
                render: 'Changement de statut avec succès',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
              })
              if (statut === 'NONLUE') {
                setIsOpen((prev) => ({
                  ...prev,
                  [actionId]: false,
                }))
              }
            }
          }
        })
        .catch((e) => {
          console.error('erreur')
        })
    }
  }

  const ActionRow = (props: any) => {
    const {action} = props
    const {code: statutCode = '', libelle: statutLibelle = ''} = action.statut || {}
    const {code: typeCode = ''} = action.type || {}

    const handleClick = () => {
      if (action?.id && onSelectDemande) {
        showModal(false)
        onSelectDemande(action.id)
      }
    }

    const displayClient = () => {
      if (!action?.client) return '';

      if (action?.client?.nom || action?.client?.prenom) {
        return `${action?.client?.nom ?? ''} ${action?.client?.prenom ?? ''}`;
      }
      if (action?.client?.nomSociete) {
        return action?.client?.nomSociete;
      }
      if (action?.client?.email) {
        return action?.client?.email;
      }
      if (action?.client?.telephone) {
        return action?.client?.telephone;
      }
      if (action?.client?.mobile) {
        return action?.client?.mobile;
      }

      return '';
    }

    return (
      <div className={'border border-muted rounded-1 mb-3 p-3'}>
        <div className='d-flex justify-content-between align-items-center mb-3'>
          <div>
            <div className='text-muted mx-8 text-start' style={{fontSize: '0.75rem'}}>
              {moment(action?.dateEcheance).format('DD/MM/YYYY, H:mm:ss')}
            </div>
            {/*<div className='pe-0'></div>*/}
            <div className='text-hover-primary'>
              <i
                className={`bi bi-exclamation-triangle-fill text-danger mx-2 ${
                  action?.prioritaire ? '' : 'invisible'
                }`}
                data-bs-toggle='tooltip'
                title='Prioritaire'
              />
              <span className='text-hover-primary'>
                {action.titre}
                {action.client ? ` ${displayClient()}` : ' '}
              </span>
              {action?.demande && (
                <span
                  onClick={handleClick}
                  style={{
                    cursor: 'pointer',
                  }}
                >
                  {' '}
                  <i className='badge badge-light me-2'>Demande n°</i>
                  <i className='badge badge-info badge-circle' style={{fontStyle: 'normal'}}>
                    {action.demande.id}
                  </i>{' '}
                </span>
              )}{' '}
              <span className={`badge ${statutColors[statutCode] || 'badge-light'} my-1`}>
                {`${statutLibelle}`}
              </span>
              {action.dateEcheance &&
                isDateExpired(action.dateEcheance) &&
                action.type.code !== 'MESS TELEVENDEUR' && (
                  <span className='badge badge-light-danger ms-2 my-1'>Échéance dépassée</span>
                )}
            </div>
          </div>
          <div className={'d-flex align-items-center gap-2'}>
            {(typeCode === 'MESS CLIENT' || typeCode === 'MESS TELEVENDEUR') &&
              (!isOpen[action?.id] ? (
                <div className=''>
                  <button
                    className={`btn btn-sm btn-icon ${
                      action.statut.code === 'LU' ? 'btn-light-primary' : 'btn-light-danger'
                    }`}
                    onClick={() => {
                      setIsOpen((prev) => ({
                        ...prev,
                        [action?.id]: !prev[action?.id],
                      }))
                    }}
                    title='Voir les messages'
                  >
                    <KTSVG
                      path='/media/icons/duotune/communication/com012.svg'
                      className='svg-icon-1'
                    />
                  </button>
                </div>
              ) : (
                <div className={'d-flex gap-3'}>
                  {action.statut.code === 'LU' && (
                    <button
                      className='btn btn-sm btn-icon btn-light-info text-hover-white'
                      onClick={() => changeStatusMessage('NONLUE', action.id)}
                      title='Marquer comme non lu'
                    >
                      {/*<KTSVG path='/media/icons/duotune/arrows/arr012.svg' className='svg-icon-1' />*/}
                      {/*<i className='bi bi-check2-all fs-1'></i>*/}
                      <i className='bi bi-envelope-x fs-1'></i>
                    </button>
                  )}
                  <button
                    className='btn btn-sm btn-icon btn-light-danger text-hover-white'
                    onClick={() => {
                      if (action.statut.code === 'NONLUE') {
                        changeStatusMessage('LU', action.id)
                      }
                      setIsOpen((prev) => ({
                        ...prev,
                        [action.id]: false,
                      }))
                    }}
                    aria-label='Fermer'
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr061.svg'
                      className='svg-icon svg-icon-2x'
                    />
                  </button>
                </div>
              ))}

            {statutCode !== 'TERMINEE' &&
              typeCode !== 'MESS CLIENT' &&
              typeCode !== 'MESS TELEVENDEUR' && (
                <button
                  className={`btn btn-sm btn-icon text-hover-white ${
                    statutCode === 'NOUVELLE' ? 'btn-light-info' : 'btn-light-danger'
                  }`}
                >
                  <i
                    className={`bi ${
                      statutCode === 'NOUVELLE'
                        ? 'bi-play-circle text-success'
                        : 'bi-stop-circle text-danger'
                    } fs-4 fw-bold text-hover-info`}
                    role='button'
                    title={statutCode === 'NOUVELLE' ? 'Démarrer' : 'Terminer'}
                    onClick={() => handleRealiserActionSubmit(action)}
                  />
                </button>
              )}
          </div>
        </div>
        {(typeCode === 'MESS CLIENT' || typeCode === 'MESS TELEVENDEUR') && (
          <ViewMessageAction
            action={action}
            changeStatusMessage={changeStatusMessage}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />
        )}
      </div>
    )
  }

  const isDateExpired = (dueDateStr: string): boolean => {
    if (!dueDateStr) {
      return false
    }

    const now = moment()
    const dueDate = moment(dueDateStr, 'YYYY-MM-DD HH:mm:ss')

    return now.isAfter(dueDate)
  }

  return (
    <Container>
      <Accordion>
        {Object.entries(groupedByType).map(([type, actions], index) => {
          const actionsFiltered = actions.filter(a => a?.statut?.code !== 'LU' && a?.statut?.code !== 'TERMINEE')
          return (
            <Accordion.Item eventKey={index.toString()} key={type}>
              <Accordion.Header>
                {type} ({actionsFiltered.length})
              </Accordion.Header>
              <Accordion.Body>
                {actionsFiltered.map((action: any) => (
                  <ActionRow key={`action-${action.id}`} action={action} />
                ))}
              </Accordion.Body>
            </Accordion.Item>
          )
        })}
      </Accordion>
    </Container>
  )
}

export {ViewActionForm}
